export default {
    limitForThisAssembly: 'Use only for this 3D group',
    visibilityFilter: 'Visibility',
    placeholderSearch: 'Suche',
    teamFilter: 'Teams',
    stateSelect: 'State',
    minValue: 'From',
    maxValue: 'To',
    search: 'Text search',
    placeholder: 'Enter text here',
    app: 'App',
    webapp: 'Webapp',
    assembly: '3D-Group',
    model: '3D-Element',
    helper: 'vHelper',
    tbl: 'Table',
    obj: 'Object',
    sensor: 'Sensor',
    feed: 'Feed',
    typeSelect: 'Type Selection',
    tagFilter: 'Tags',
    orgFilter: 'Organizations',
    fieldSelector: 'Filter a field',
    all: 'All',
    none: 'None',
    private: 'Private',
    public: 'Public',
    global: 'Global',
    allItemsInSetAreIn: 'All parts of these selection groups are already included in the export profile',
    allItemsAreSet: 'All parts of this selection group are already added',
    add: 'Add',
    remove: 'Remove',
    unmatched: 'Some parts are not yet added',
    instancesIn: 'Parts contained',
    removeAll: 'Remove all parts',
    selectionSetFilter: 'If you created a group in vSTAGE for this 3D object here, you can select it now and use it as a filter.',
    showGlobalProfiles: 'Show global profiles',
    executedItems: 'Applied profiles',
    noExecutedItems: 'No profiles applied on this object',
    pivotInfo: 'A pivot marks the point around which an object rotates – this might be on the side for the hinge on a door or centered for an office chair',
    Pivots: 'Pivots',
    EditFilter: 'Edit Administrational Info',
    showCodeView: 'Show code view',
    limitedToAssembly: 'For this 3D group',
    limitedToGlobal: 'Global profiles',
    selectionSetHint: '(The selection sets are only shown if they were created in vSTAGE and uploaded to the model)',
    create: 'Create',
    filters: 'Filters',
    merge: 'Merge',
    corrections: 'Corrections',
    importCSV: 'Import CSV',
    itemsSelected: 'Items selected',
    pivotPlacement: 'Rotation center placement (pivots)',
    fromSelectionGroups: 'items from Selection Groups',
    summary: 'Summary',
    startSettings: 'Start settings',
    usedInProjects: 'Used in projects',
    reload: 'Reload',
    totalTime: 'Total time',
    globalExportprofiles: 'Global export profiles',
    localExportprofiles: 'Local export profiles',
    sourceOriginal: 'Original Position',
    top: 'Top',
    bottom: 'Bottom',
    left: 'Left',
    right: 'Right',
    front: 'Front',
    back: 'Back',
    center: 'Center',
}